// extracted by mini-css-extract-plugin
export default {"mail-center":"mailCenter_mail-center__QPstg","mail-center__inner":"mailCenter_mail-center__inner__XE66x","mail-center__heading":"mailCenter_mail-center__heading__U-gdE"};